export default __webpack_public_path__ + "static/media/worst.a507319b.svg";